import { render, staticRenderFns } from "./DenunciationsQuestionsHeader.vue?vue&type=template&id=034f5f54&scoped=true&"
import script from "./DenunciationsQuestionsHeader.vue?vue&type=script&lang=js&"
export * from "./DenunciationsQuestionsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DenunciationsQuestionsHeader.vue?vue&type=style&index=0&id=034f5f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f5f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
